import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_date_picker = _resolveComponent("el-date-picker");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                type: _ctx.type,
                format: _ctx.dateType,
                placeholder: _ctx.placeholder || 'Choose a date',
                disabled: _ctx.disabled,
                style: { "width": "100%" },
                "disabled-date": _ctx.disabledDate
            }, null, 8 /* PROPS */, ["modelValue", "type", "format", "placeholder", "disabled", "disabled-date"])
        ]),
        _: 1 /* STABLE */
    }));
}
